import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { ReplaySubject } from 'rxjs';
import { ApiService } from './api.service';
import { AnalyticsService } from './analytics.service';
import { ModalAnimationService } from './modal-animation.service';
import { SupportChatComponent } from '../../shared/modals/support-chat/support-chat.component';

interface TawkMessageEvent extends Event {
  detail: {
    message: string;
  };
}

interface WindowWithTawk extends Window {
  Tawk_API?: {
    isVisitorEngaged(): boolean;
  };
  Tawk_LoadStart?: unknown;
}

declare const window: WindowWithTawk;

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private listenersAttached = false;
  private hasNewTawkEventSubject = new ReplaySubject<boolean>(1);

  constructor(
    private modalCtrl: ModalController,
    private api: ApiService,
    private analyticsService: AnalyticsService,
    private mAnimation: ModalAnimationService,
  ) {
    this.hasNewTawkEventSubject.next(false);
  }

  private handleMessage = (msg: TawkMessageEvent): void => {
    this.hasNewTawkEventSubject.next(true);
    this.showSupportMessage(msg.detail.message);
  };

  /**
   * Показывает модальное окно поддержки.
   * При закрытии проверяет есть ли активный чат и добавляет события на проверку новых сообщений от агента
   */
  async showSupportChat(): Promise<void> {
    this.hasNewTawkEventSubject.next(false);
    this.analyticsService.phCapture('Поддержка: Окно показано');
    
    const modal = await this.modalCtrl.create({
      component: SupportChatComponent,
      cssClass: 'right-side-modal',
      enterAnimation: this.mAnimation.enterAnimation,
      leaveAnimation: this.mAnimation.leaveAnimation,
    });

    await modal.present();

    const { role } = await modal.onDidDismiss();

    this.analyticsService.phCapture('Поддержка: Окно закрыто');

    if (role === 'error') {
      this.analyticsService.phCaputeException('Не удалось подключиться к чату поддержки');
      this.api.toastPresent('Не удалось подключиться к чату поддержки. Повторите попытку позже.');
      window.Tawk_API = undefined;
      window.Tawk_LoadStart = undefined;
    } else {
      if (window.Tawk_API?.isVisitorEngaged() && !this.listenersAttached) {
        window.addEventListener('tawkChatMessageAgent', this.handleMessage as EventListener);
        this.listenersAttached = true;
      }
    }
  }

  /**
   * Показывает тоаст-сообщение из чата поддержки
   * @param message текст сообщения
   */
  private showSupportMessage(message: string): void {
    this.api.toastPresent(message, true, 'Чат поддержки');
  }

  /**
   * Сбрасывает статус новых событий в чате поддержки
   */
  resetNewTawkEvent(): void {
  
    this.hasNewTawkEventSubject.next(false);
  }

  getHasNewTawkEventChanges() {
    return this.hasNewTawkEventSubject.asObservable();
  }
} 